const TypeImageAttachment = 'image'
const TypeWhiteboardAttachment = 'whiteboard'
const TypeFileAttachment = 'file'
const TypeEmbeddedVideoAttachment = 'embeddedVideo'
const TypeLinkAttachment = 'link'
const TypeProjectAttachment = 'project'
const TypeVideoAttachment = 'video'
const TypePollAttachment = 'poll'
const TypeIframeAttachment = 'iframe'
const TypeMeetingAttachment = 'meeting'

const AttachmentTypes = [
  TypeImageAttachment,
  TypeWhiteboardAttachment,
  TypeFileAttachment,
  TypeEmbeddedVideoAttachment,
  TypeLinkAttachment,
  TypeProjectAttachment,
  TypeVideoAttachment,
  TypePollAttachment,
  TypeIframeAttachment,
  TypeMeetingAttachment
]

export default {
  data: function () {
    return {
      TypeImageAttachment,
      TypeWhiteboardAttachment,
      TypeFileAttachment,
      TypeEmbeddedVideoAttachment,
      TypeLinkAttachment,
      TypeProjectAttachment,
      TypeVideoAttachment,
      TypePollAttachment,
      TypeIframeAttachment,
      TypeMeetingAttachment,
      AttachmentTypes
    }
  }
}
